<template>
<div class="page">
  <div class="invitation_box">
    <div class="code_box">
      <div class="text">邀请码：</div>
      <div class="code">{{inviteCode}}</div>
    </div>
    <div @click="copy" :data-clipboard-text="inviteCode" class="copy_btn">复制</div>
  </div>
  <div class="experience_btn" @click="toDownLoad"></div>
</div>
</template>
<script>
export default {
  data () {
    return {
      inviteCode:'092646',                     //邀请码
    }
  },
  components: {
  },
  created () {
    this.inviteCode = this.$route.query.inviteCode;
  },
  mounted () {
    const clipboard = new this.clipboard('.copy_btn');
  },
  computed:{
  },
  methods: {
    copy(){
      this.$toast('复制成功');
    },
    // 去下载页
    toDownLoad(){
      window.location.href = 'https://www.zhuowendata.com/app/zwtb.html'; 
    }
  }
}
</script>
<style lang="less" scoped>
.page{
  width: 100%;
  height: 100vh;
  background: #FE5F55 url('../../assets/images/invitation/down_load_bg.png') no-repeat;
  background-size: contain;
  padding-top: 1px;
  .invitation_box{
    width: 471px;
    display: flex;
    align-items: center;
    margin: 75vh auto 0;
    .code_box{
      height: 68px;
      display: flex;
      align-items: center;
      padding: 0 40px 0 25px;
      box-sizing: border-box;
      border: 4px solid #fff;
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
      .text{
        font-size: 28px;
        line-height: 40px;
        color: #fff;
      }
      .code{
        font-size: 42px;
        line-height: 59px;
        font-weight: bold;
        color: #fff;
      }
    }
    .copy_btn{
      width: 123px;
      height: 68px;
      background-color: #fff;
      text-align: center;
      line-height: 68px;
      font-size: 32px;
      font-weight: bold;
      color: #FE5F55;
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
    }
  }
  .experience_btn{
    margin: 62px auto 0;
    width: 380px;
    height: 108px;
    background: url('../../assets/images/invitation/experience_btn.png') no-repeat;
    background-size: cover;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/invitation/downLoad.vue